<template>
  <div class="product-formats">
    <h2 class="title">ELIGE UN FORMATO</h2>
    <div class="formats">
      <button 
        :class="{selected: format.CODFORMATO === current.CODFORMATO}"
        class="btn btn-light btn__format" 
        v-for="format in formats" 
        :key="format.CODFORMATO"
        @click="selectFormat(format)"
      >
      <span class="badge badge-danger price">
        {{(format.PVP||0).toFixed(2)}}€
      </span>
      {{ format.DESCRIPCION }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    formats: { required: true }
  },
  data() {
    return {
      current: {}
    }
  },
  methods: {
    selectFormat(format) {
      this.$emit('formatChanged', format)
      this.current = format
    }
  }
}
</script>
<style lang="scss">
.product-formats {
  .btn__format {
    border: .2rem solid transparent;
    position: relative;
    
    &.selected {
      border-color: #309930;
    }

    .price {
      position: absolute;
      top: .42rem;
      right: .42rem;
    }
  }
}
</style>

